// hooks/useDailyActivityListData.ts
import { getDailyActivity } from '@api/services/analytics.service';
import useDataQuery from '@hooks/use-data-query';
import { useMemo } from 'react';

const useDailyActivityListData = (startDate: string, endDate: string) => {
    const query = useDataQuery(['daily-activity', startDate, endDate], () => getDailyActivity(startDate, endDate));

    const data = useMemo(() => query.data || [], [query.data]);

    return {
        data,
        isLoading: query.isLoading,
    };
};

export default useDailyActivityListData;
